import moment from 'moment-timezone';

import errorHandlers from '@/services/error-handlers';

// TODO: write tests
async function validateOrderFulfillmentTime({ dispatch, rootGetters }) {
  const merchant = rootGetters['merchant/merchant'];

  try {
    const pickupDaysResult = await dispatch('locations/getPickupDaysforSelectedLocation', {}, { root: true });

    if (pickupDaysResult.length) {
      const { fulfillmentTime: userSessionTimestamp } = rootGetters['session/orderDetails'];

      const pickupBypassWindow = Number(merchant.features['bypass-pickup-time-warning-minutes'] || 10);

      const earliestTimestamp = pickupDaysResult[0].times[0].value;

      const now = moment();

      const momentEarliestTimestamp = moment(earliestTimestamp);

      const momentUserSessionTimestamp = moment(userSessionTimestamp);

      const isAsapTimeMatch = momentUserSessionTimestamp === momentEarliestTimestamp;

      const isUserSessionTimestampOutdated = momentUserSessionTimestamp.isBefore(momentEarliestTimestamp);

      let isFutureAsapTimeslotVerificationRequired = false;

      let isTimeslotVerificationRequired = false;

      if (isAsapTimeMatch) {
        isFutureAsapTimeslotVerificationRequired = momentEarliestTimestamp.diff(now, 'hours') >= 5;
      }
      else if (isUserSessionTimestampOutdated) {
        /** Note:
         * If timeslot is outdated, the order fulfillment time MUST get updated so that a valid time in the future is provided on submit.
         */
        await dispatch('setOrderFulfillmentTime', earliestTimestamp);

        /** Note:
         * If users time is outdated, but still falls within bypass window verification is not required,
         * however if the timeslot is outside of the bypass window then require verificaiton.
        */
        if (momentEarliestTimestamp.diff(momentUserSessionTimestamp, 'minutes') > pickupBypassWindow) {
          isTimeslotVerificationRequired = true;
        }
      }

      const validationResult = {
        previousSelectedTime: userSessionTimestamp,
        isTimeslotVerificationRequired,
        isFutureAsapTimeslotVerificationRequired
      };

      return validationResult;
    }
  }
  catch (error) {
    errorHandlers.silent(error);
  }
}

export { validateOrderFulfillmentTime };

